// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const api:string = 'https://2880-201-148-32-146.ngrok.io'
//const api:string = 'http://localhost:9082'
//const api:string = 'https://leader-people.herokuapp.com'
//const api:string = 'https://servicecoders.com:9082'

export const environment = {
  production: true,
  serverUrl: api
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
